const e = {
  name: "Message",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0001 1C5.92006 1 1.00006 5.93 1.00006 12C1.00006 13.87 1.49006 15.63 2.31006 17.17L1.04006 21.73L0.560059 23.44L2.27006 22.96L6.83006 21.69C8.37006 22.51 10.1301 23 12.0001 23C18.0801 23 23.0001 18.08 23.0001 12C23.0001 5.92 18.0801 1 12.0001 1ZM12.0001 21C10.3301 21 8.77006 20.55 7.44006 19.76L7.07006 19.54L6.66006 19.66L3.44006 20.56L4.34006 17.34L4.46006 16.93L4.24006 16.56C3.45006 15.23 3.00006 13.67 3.00006 12C3.00006 7.03 7.03006 3 12.0001 3C16.9701 3 21.0001 7.03 21.0001 12C21.0001 16.97 16.9701 21 12.0001 21Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as Message
};
